import {makeSellerUrl} from '@frontend/helpers'
import type {ChatDetailsData} from '@frontend/modules/private/chats/ChatsModuleTypes'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {getChatHeaderData} from '../heplers/getChatHeaderData'
import {ChatActionsMenu} from './ChatActionsMenu'
import {ChatCover} from './ChatCover'

interface Props {
    chat: ChatDetailsData
    // Отображение в мини-чате?
    miniChat?: boolean
    // Удаление чата.
    onDelete: (chat: ChatDetailsData) => void
    // Прочитать все сообщения в чате.
    onReadAllMessages: (chat: ChatDetailsData) => void
    // Показать окно добавления отзыва о продавце.
    onAddReview: (chat: ChatDetailsData) => void
    // Состояние выполнения действия с чатом.
    disabled?: boolean
}

// Данные объявления или исполнителя услуг в заголовке чата.
export function ChatDetailsCardHeaderInfo(props: Props) {

    const {
        chat,
        miniChat,
        disabled,
        onReadAllMessages,
        onDelete,
        onAddReview,
    } = props

    const headerData = getChatHeaderData(chat)

    return (
        <>
            <div className="flex-1 d-flex flex-row align-items-center gap-small overflow-hidden">
                <ChatCover
                    coverImage={headerData.coverImage}
                    userName={chat.otherUser.name}
                    small={miniChat}
                />
                <div className="flex-1 d-flex flex-column gap-1 overflow-hidden">
                    <Link
                        to={makeSellerUrl(chat.otherUser.id)}
                        target="_blank"
                        className="fw-800 link-dark text-truncate"
                        rel="noreferrer"
                    >
                        {headerData.sellerName}
                    </Link>
                    {/* В мини-чате мало места по высоте: товар и цена в одной строке, название обрезается. */}
                    <div
                        className={clsx(
                            'd-flex col-gap-3',
                            miniChat
                                ? 'flex-row align-items-center overflow-hidden'
                                : 'flex-column align-items-start flex-md-row align-items-md-center'
                        )}
                    >
                        <Link
                            to={headerData.itemUrl}
                            target="_blank"
                            className="cabinet-chat-messages-offered-item-link text-truncate mw-100"
                            rel="noreferrer"
                        >
                            {headerData.title}
                        </Link>
                        {chat.ad && (
                            <span className={clsx('fw-700 text-nowrap flex-shrink-0', !miniChat && 'fs-5')}>
                                {chat.ad.price}
                            </span>
                        )}
                    </div>
                </div>
            </div>
            <ChatActionsMenu
                chat={chat}
                miniChat={miniChat}
                disabled={disabled}
                onRead={onReadAllMessages}
                onDelete={onDelete}
                onAddReview={onAddReview}
                framedButton
                className="flex-shrink-0"
            />
        </>
    )
}
